import React from 'react'

export function SignOutIcon({ size = 16, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d="M9.5 2H3.5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h6" />
      <path d="M6.75 8h7.75" />
      <path d="M11.75 5.25L14.5 8l-2.75 2.75" />
    </svg>
  )
}
